import React from "react";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";
import { cloud } from "@vitalsource/vstui/colors";
import MustReadContainer from "./must-read-container";
import TrendingContainer from "./trending-container";
import { styledMedia } from "../../../../components/mediaquery/breakpoints";
import CenteredSpinner from "../../../../components/spinner/centered-spinner";

const LEFT_BASIS = 620;
const RIGHT_BASIS = 428;
const INNER_SPACE = 63;
const TOTAL_BASIS = LEFT_BASIS + RIGHT_BASIS + INNER_SPACE;

const OuterContainer = styled.div`
  background-color: white;
  border: 1px solid ${cloud.getShade(4)};
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  padding: 46px 75px 55px 75px;
  width: 100%;
  justify-content: space-between;

  & > *:first-child:not(:last-child) {
    width: ${(100 * LEFT_BASIS) / TOTAL_BASIS}%;
  }

  & > *:last-child:not(:first-child) {
    width: ${(100 * RIGHT_BASIS) / TOTAL_BASIS}%;
  }

  ${styledMedia.medium`
    flex-direction: column;
    padding: 29px 64px;
    padding-bottom: 10px;

    & > *:first-child:not(:last-child) {
      width: 100%;
      margin-bottom: 40px;
    }
    
    & > *:last-child:not(:first-child) {
      width: 100%;
    }
  `}

  ${styledMedia.small`
    padding: 16px 18px;
    border: none;
    border-radius: 0;
    background: none;
    
    & > *:first-child:not(:last-child) {
      margin-bottom: 30px;
    }
  `}
`;

const LoadingContainer = styled(OuterContainer)`
  height: 400px;
  padding: 0;
  display: block;
`;

class TopReadsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  expandSwimlane = () => {
    this.props.onViewAll();
  };

  render() {
    const { recommended, popular, loading } = this.props;
    if (loading) {
      return (
        <LoadingContainer>
          <CenteredSpinner />
        </LoadingContainer>
      );
    }

    return (
      <OuterContainer>
        {recommended && <MustReadContainer asset={recommended} />}
        <TrendingContainer popular={popular} onViewAll={this.expandSwimlane} />
      </OuterContainer>
    );
  }
}

TopReadsContainer.propTypes = {
  recommended: PropTypes.object,
  popular: PropTypes.array,
  onViewAll: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default withTheme(TopReadsContainer);
